module.exports = __webpack_public_path__ + "static/img/wenchaung.97946dc1.png";